// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
function useTouch(preventDefaultOpt, stopPropagationOpt, onTouchEnd) {
  var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
  var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
  var hasTouchMovedRef = React.useRef(false);
  var onTouchStart = function (e) {
    if (preventDefault) {
      e.preventDefault();
    }
    if (stopPropagation) {
      e.stopPropagation();
    }
    hasTouchMovedRef.current = false;
  };
  var onTouchMove = function (e) {
    if (preventDefault) {
      e.preventDefault();
    }
    if (stopPropagation) {
      e.stopPropagation();
    }
    hasTouchMovedRef.current = true;
  };
  var onTouchEnd$1 = function (e) {
    if (hasTouchMovedRef.current) {
      return;
    } else {
      if (preventDefault) {
        e.preventDefault();
      }
      if (stopPropagation) {
        e.stopPropagation();
      }
      return Curry._1(onTouchEnd, e);
    }
  };
  return {
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd$1
  };
}
function useMouse(preventDefaultOpt, stopPropagationOpt, onMouseUp) {
  var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
  var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
  var isMouseDownRef = React.useRef(false);
  var onMouseDown = function (e) {
    if (preventDefault) {
      e.preventDefault();
    }
    if (stopPropagation) {
      e.stopPropagation();
    }
    isMouseDownRef.current = true;
  };
  var onMouseLeave = function (e) {
    isMouseDownRef.current = false;
  };
  var onMouseUp$1 = function (e) {
    if (isMouseDownRef.current) {
      if (preventDefault) {
        e.preventDefault();
      }
      if (stopPropagation) {
        e.stopPropagation();
      }
      Curry._1(onMouseUp, e);
    }
    isMouseDownRef.current = false;
  };
  return {
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp$1,
    onMouseLeave: onMouseLeave
  };
}
export { useTouch, useMouse };
/* react Not a pure module */